import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PageHeader from '../../components/PageHeader';
import ScoreCard from '../../components/ScoreCard';
import LoadingSpinner from '../../components/LoadingSpinner';
import { adminApi } from '../../services/admin';

export default function AdminVendorDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: vendor, isLoading } = useQuery({
    queryKey: ['admin', 'vendors', id],
    queryFn: () => adminApi.getVendor(id!),
    enabled: !!id,
  });

  if (isLoading) return <div className="flex justify-center py-12"><LoadingSpinner size="lg" /></div>;
  if (!vendor) return <div className="text-center py-12"><p className="text-sm text-slate-500">Vendor not found</p></div>;

  return (
    <>
      <PageHeader
        title={vendor.name}
        description="Vendor organization detail"
        actions={
          <button onClick={() => navigate('/admin/vendors')} className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border-2 border-slate-200 rounded-xl hover:bg-slate-50">
            Back to Vendors
          </button>
        }
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        <div className="lg:col-span-2 rounded-2xl border border-slate-100 bg-white p-6">
          <h2 className="text-lg font-semibold text-slate-900 mb-4">Organization Info</h2>
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
            {[
              ['Name', vendor.name],
              ['City', vendor.city || '—'],
              ['State', vendor.state || '—'],
              ['Phone', vendor.phone || '—'],
              ['Website', vendor.website || '—'],
              ['Members', String(vendor.member_count)],
              ['Created', new Date(vendor.created_at).toLocaleDateString()],
            ].map(([label, value]) => (
              <div key={label}>
                <dt className="text-xs font-medium text-slate-400 uppercase">{label}</dt>
                <dd className="mt-1 text-sm text-slate-900">{value}</dd>
              </div>
            ))}
          </dl>
        </div>
        <ScoreCard label="Vendor Score" score={vendor.current_vendor_score} size="lg" />
      </div>
    </>
  );
}
